// @file Surface permissions store
import { getVuexStore } from '@@/bits/pinia'
import { isRegistered } from '@@/bits/user_model'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceSharePanelStore } from '@@/pinia/surface_share_panel'
import { useSurfaceWishArrangementStore } from '@@/pinia/surface_wish_arrangement'
import type { RootState } from '@@/vuexstore/surface/types'
import { GroupByTypes } from '@padlet/arvo'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useSurfacePermissionsStore = defineStore('surfacePermissions', () => {
  const surfaceVuexStore = getVuexStore<RootState>() // For gradual conversion to pinia

  const surfaceStore = useSurfaceStore()
  const surfaceWishArrangementStore = useSurfaceWishArrangementStore()
  const surfaceSharePanelStore = useSurfaceSharePanelStore()

  const amIOwner = computed<boolean>(() => surfaceVuexStore?.getters.amIOwner)
  const amICollaborator = computed<boolean>(() => surfaceVuexStore?.getters.amICollaborator)
  const amIRegistered = computed<boolean>(() => isRegistered(surfaceVuexStore?.state.user))
  const canIAdminister = computed<boolean>(() => surfaceVuexStore?.getters.canIAdminister)
  const canIRemake = computed<boolean>(() => surfaceVuexStore?.getters.canIRemake)
  const canIEdit = computed<boolean>(() => surfaceVuexStore?.getters.canIEdit)
  const canIComment = computed<boolean>(() => surfaceVuexStore?.getters.canIComment)
  const canIReact = computed<boolean>(() => surfaceVuexStore?.getters.canIReact)
  const canIWrite = computed<boolean>(() => surfaceVuexStore?.getters.canIWrite)
  const canIModerate = computed<boolean>(() => surfaceVuexStore?.getters.canIModerate)
  const canIPost = computed<boolean>(() => surfaceVuexStore?.getters.canIPost)
  const canIDragSections = computed(
    () =>
      canIModerate.value && surfaceWishArrangementStore.wishGroupBy === GroupByTypes.Section && !surfaceStore.isFrozen,
  )
  const requireApprovalForPosts = computed<boolean>(() => surfaceVuexStore?.getters.requireApproval)
  const visitorsCanModerate = computed<boolean>(() => surfaceSharePanelStore.visitorsCanModerate)

  return {
    // getters
    amIOwner,
    amICollaborator,
    amIRegistered,
    canIAdminister,
    canIModerate,
    canIRemake,
    canIPost,
    canIComment,
    canIReact,
    canIWrite,
    canIEdit,
    canIDragSections,
    requireApprovalForPosts,
    visitorsCanModerate,
  }
})
